import UrlGenerator from '@paybis/frontend-common-lib/src/services/url';

export default {
  crypto (cryptoSlug, language) {
    const link = `/${cryptoSlug}-calculator/`;

    return UrlGenerator.generate(link.toLowerCase(), {}, language);
  },
  cryptoToFiat (cryptoCode, fiatCode, language) {
    const link = `/${cryptoCode}-to-${fiatCode}/`;

    return UrlGenerator.generate(link.toLowerCase(), {}, language);
  },
  cryptoToFiatWithAmount (cryptoCode, fiatCode, cryptoAmount, language) {
    const link = `/${cryptoCode}-to-${fiatCode}/${cryptoAmount}/`;

    return UrlGenerator.generate(link.toLowerCase(), {}, language);
  },
  fiatToCryptoWithAmount (fiatCode, cryptoCode, fiatAmount, language) {
    const link = `/${fiatCode}-to-${cryptoCode}/${fiatAmount}/`;

    return UrlGenerator.generate(link.toLowerCase(), {}, language);
  },
};
